// Background music playback (SunnyLand Music pack — see public-license.pdf
// under /SunnyLand Music in the repo root). One <audio> element, reused
// across screens, swapped/looped by track src; volume and mute are driven by
// the Settings screen's soundOn/volume state so there's a single source of
// truth instead of each screen managing its own player.

const TRACK_BY_SLUG: Record<string, string> = {
	"rk-beach-dawn": "happywalking",
	"beach-road-cruise": "arcade",
	"dolphins-nose": "exploration",
	"yarada-shores": "summer-nights",
	"kailasagiri-ropeway": "going-up",
	"rushikonda-surf": "synthwave-palms",
	"simhachalam-climb": "magic-cliffs",
	"harbour-nights": "maniac",
	"araku-monsoon": "world-wanderer",
	"kambalakonda-wild": "joyful",
};
const MENU_TRACK = "menu-theme";

let el: HTMLAudioElement | null = null;
let currentTrack: string | null = null;

function ensureElement(): HTMLAudioElement {
	if (!el) {
		el = new Audio();
		el.loop = true;
	}
	return el;
}

function trackUrl(name: string) {
	return `/assets/music/${name}.ogg`;
}

function playTrack(name: string, soundOn: boolean, volume: number) {
	const audio = ensureElement();
	audio.volume = Math.max(0, Math.min(1, volume / 100));
	if (currentTrack !== name) {
		currentTrack = name;
		audio.src = trackUrl(name);
	}
	if (soundOn) {
		// Autoplay can be blocked until a user gesture; this is always called
		// from a click/keypress-driven screen transition so it succeeds, but
		// swallow the rejection anyway rather than let it surface as an
		// unhandled promise rejection.
		audio.play().catch(() => {});
	} else {
		audio.pause();
	}
}

export function playMenuMusic(soundOn: boolean, volume: number) {
	playTrack(MENU_TRACK, soundOn, volume);
}

export function playLevelMusic(levelSlug: string, soundOn: boolean, volume: number) {
	playTrack(TRACK_BY_SLUG[levelSlug] ?? MENU_TRACK, soundOn, volume);
}

// Applies a live soundOn/volume change to whatever track is already playing,
// without restarting it (used when the user tweaks Settings mid-run).
export function updateMusicSettings(soundOn: boolean, volume: number) {
	if (!el) return;
	el.volume = Math.max(0, Math.min(1, volume / 100));
	if (soundOn && currentTrack) el.play().catch(() => {});
	else el.pause();
}

export function stopMusic() {
	el?.pause();
}
